// extracted by mini-css-extract-plugin
export default {"body":"EditAccountModal_body__vTT33","two_columns":"EditAccountModal_two_columns__fCW4R","footer":"EditAccountModal_footer__9yscp"};